import type { FC } from 'react';
import { Suspense } from 'react';
import { CircularProgress } from '@mui/material';
import StickyLayout from 'components/layout/StickyLayout';
import { Trends, TrendsTimestamp } from 'features/trends';

const TrendsPage: FC = () => (
  <StickyLayout
    id="trends-page"
    pageTitle="Trends"
    titleAdornment={
      <Suspense fallback={<CircularProgress size={16} color="inherit" />}>
        <TrendsTimestamp />
      </Suspense>
    }
  >
    <Trends />
  </StickyLayout>
);

export default TrendsPage;
